import type { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';

import { config } from '../../../../config/config';
import { MenuDropdown } from '../../../shared/components/menu-dropdown/menu-dropdown';
import { useContextNavigate } from '../../../shared/hooks/use-context-navigate';
import { selectLocale } from '../../../shared/store/locale.store';
import { useGetAllDocumentsQuery } from '../../queries/documents.graphql';

export interface IDocumentDropdownProps {
    className?: string;
    slug: string;
}

export const DocumentsDropdown: FunctionComponent<IDocumentDropdownProps> = ({
    className,
    slug,
}) => {
    const locale = useSelector(selectLocale);
    const navigate = useContextNavigate();

    const [{ data: documentSlugsList, fetching }] = useGetAllDocumentsQuery({
        variables: {
            xTenantID: config.TENANT_ID,
            locale: locale,
            skinId: config.SKIN_ID,
        },
    });

    const slugsList = documentSlugsList?.getAllDocuments;

    if (fetching || !slugsList) {
        return <></>;
    }

    if (!slugsList || !slugsList.length) {
        return null;
    }

    const selectedItem = slugsList.find((item) => item?.slug === slug);

    return (
        <div className={className}>
            <MenuDropdown
                onSelect={(item) => {
                    navigate(`/documents/${item.value}`);
                }}
                selectedItemId={selectedItem?.id}
                items={slugsList.map((slug) => ({
                    value: slug?.slug,
                    name: slug?.title ?? '',
                    id: slug?.id,
                }))}
            />
        </div>
    );
};
